module.exports = __webpack_public_path__ + "img/6L.a2d69adf.png";